import { afterNextRender, Component, OnInit, Renderer2 } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { LanguageService, Locale } from './services/language.service'
import { NotificationModal } from './components/common/notification-modal/notification-modal.component'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationModal, TranslatePipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'RDA_Volunteer_Coach_Portal'

  constructor(private langService: LanguageService,private renderer2: Renderer2) {
    langService.preInit()
    afterNextRender(() => {
      console.debug('Restore Language setting.')
      this.langService.restore()
    })
  }

  ngOnInit(): void {
    this.langService.langSource.subscribe((locale) => {
      this.changeLangFont(locale)
    })
  }

  changeLangFont(locale: Locale) {
    const body = document.body
    if (locale === Locale.EN) {
      this.renderer2.setAttribute(body, 'data-lang-type', 'en')
    } else {
      this.renderer2.setAttribute(body, 'data-lang-type', 'zh')
    }
  }
}
